import { call, takeEvery } from 'typed-redux-saga';

import { Connection } from '../Connection';
import { debugHalt } from '../dtmf/debug-menu/actions';

export function* debugSaga({ connection }: { connection: Connection }) {
    yield* takeEvery(debugHalt, function* () {
        yield* call([connection, connection.debugHalt]);
    });
}
